import { OpalApiComponent, OpalApiResponseDocument } from '@opallabs/api/v3'

const sortByGroupName = (
  a: OpalApiComponent<'V3', 'user_group'>,
  b: OpalApiComponent<'V3', 'user_group'>
) => {
  if (a.attributes.name.toLowerCase() > b.attributes.name.toLowerCase())
    return 1
  if (a.attributes.name.toLowerCase() < b.attributes.name.toLowerCase())
    return -1
  return 0
}

export const filterAndSortGroups = (
  responseDocument: OpalApiResponseDocument<'ReadUserGroupsV3', 200>,
  showArchived?: boolean
) => {
  let allGroups = Array.from(responseDocument.data)

  if (!showArchived) {
    allGroups = responseDocument.data.filter(
      (group) => !group.attributes.is_archived
    )
  }

  return allGroups.sort(sortByGroupName)
}
